import React, { Component } from 'react';
import styles from "../../../Assets/Styles/Components/Book/BookTime/bookTime.module.css";

class Error extends Component {
    componentDidMount() {
        document.querySelector(`.${styles.error}`).scrollIntoView({ behavior: "smooth", });
    }

    render() {
        return (
            <>
                <p className={styles.error}>{this.props.error}</p>
            </>
        );
    }
}

export default Error;
